module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sweet-modal', {
    ref: "modal",
    attrs: {
      "icon": "error",
      "title": "Server Fake Error"
    }
  }, [_vm._v(_vm._s(_vm.error) + " (Refresh until you get the sessions)\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a4bf29c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErrorModal.vue
// module id = 107
// module chunks = 1